import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType } from '@angular/http';
import { global } from '../../Models/global';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SDDispatchToFieldService {

  ROOT_URL: string = "";
  constructor(private http: Http) {
    let g: global = new global();
    this.ROOT_URL = g.getApiUrl();
  }

  GetExcelFileName(model: any): Observable<any> {
    let _body = JSON.stringify(model);
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let url = this.ROOT_URL + '/api/DispatchSDToField/CreateExcel';
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: _body,
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });
  }
  DownloadFile(model: any): Observable<any> {
    let _body = JSON.stringify(model);
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: this.ROOT_URL + "/api/DispatchSDToField/DownloadExcel",
      headers: headers,
      body: _body,
      responseType: ResponseContentType.Blob
    });
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        var blob = new Blob([res.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })
        return blob;
      });
  }
  uploadDocument(documents: File, UserId: string, RequirmentType: string,Year:any): Observable<any> {
    const formData = new FormData();
    formData.append("file", documents);
    formData.append("UserId", UserId);
    formData.append("RequirmentType", RequirmentType);
    formData.append("Year", Year);
    let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: this.ROOT_URL + "/api/DispatchSDToField/UploadFiles",
      headers: headers,
      body: formData
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });
  }

  getStockoutScreenData(requestModel: any): Observable<any> {
    let url = this.ROOT_URL + '/api/DispatchSDToField/StockOutScreen';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: JSON.stringify(requestModel)
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }
  saveFinalApprovalData(data: any, userId: any, requirmentType: any,year:number): Observable<any> {
    let _body = { "approvalList": data, "userId": userId, "requirementType": requirmentType,"year":year};
    let url = this.ROOT_URL + '/api/DispatchSDToField/FinalApprovalStockOut';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: _body
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }

  getBatchNo(wh: any, product: any): Observable<any> {
    let _body = { "wh": wh, "product": product };
    let url = this.ROOT_URL + '/api/DispatchSDToField/GetBatchNo';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: _body
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }


  getInvoiceNo(wh: any, product: any): Observable<any> {
    let _body = { "wh": wh, "product": product };
    let url = this.ROOT_URL + '/api/DispatchSDToField/GetInvoiceNo';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: _body
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }

}
